import api from '@/services/utils/apiInstance.ts'
import type { AxiosResponse } from 'axios';
import type {
  LoginRequest,
  LogoutResponse,
} from '@/types/services/auth/auth.type.ts';

class AuthService {
  async login(userData: LoginRequest): Promise<void> {
    await api.post("/api/nameplate/login", {
      identifier: userData.identifier,
      email: userData.email,
    });
  }

  async logout(): Promise<LogoutResponse> {
    const response: AxiosResponse = await api.post("/api/nameplate/logout");
    if (response.status === 200) {
      localStorage.removeItem("email");
    }
    return {
      statusCode: response.status
    }
  }
}

export default new AuthService();
